<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">

        <el-form-item label="圈子标题">
          <el-input placeholder="请输入圈子标题" v-model="formInline.quanzi">
          
          </el-input>
        </el-form-item>

        <el-form-item label="圈子动态标题">
          <el-input placeholder="请输入圈子动态标题" v-model="formInline.search">
          
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="getData">查询</el-button>
          <el-button type="primary" @click="reast">重置</el-button>
          <el-button type="primary" v-if="showBack" @click="gotoback">返回上一页</el-button>
        </el-form-item>
     
        
      </el-form>
    </div>

    <div class="common-level-rail">
      <!-- <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加圈子动态</el-button> -->
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="dynamic_id" label="ID"></el-table-column>
            
            <el-table-column prop="activity.title" label="圈子标题"></el-table-column>
            <el-table-column prop="name" label="圈子动态标题"></el-table-column>
            <!-- <el-table-column prop="name" label="圈子动态封面">
              <template slot-scope="scope">

                <img
                v-img-url="scope.row.image?scope.row.image.file_path:''"
                width="30"
                height="30"
              />
              </template>
            </el-table-column> -->
           
         
            <el-table-column prop="code" label="类型">
            </el-table-column>

            <el-table-column prop="is_free" label="是否免费">
              <template slot-scope="scope">
                <div v-if="scope.row.is_free == 0">免费</div>
                <div v-if="scope.row.is_free == 1">付费</div>
              </template>
            </el-table-column>
            

            <el-table-column prop="price" label="付费金额"></el-table-column>

            <el-table-column prop="is_commond" label="是否推荐">
              <template slot-scope="scope">
                <div v-if="scope.row.is_commond == 0">未推荐</div>
                <div v-if="scope.row.is_commond == 1">已推荐</div>
              </template>
            </el-table-column>

  
  
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                <el-button @click="jumpClick(scope.row)" type="text" size="small">查看评论</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :dynamic_id="dynamic_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import DynamicApi from '@/api/dynamic.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          quanzi:""
          
        },

        open_add:false,
        open_edit:false,
        dynamic_id:"",
        showBack:false,
      };
    },
    created() {
      if(this.$route.query.activity_id){
        this.formInline.quanzi = this.$route.query.activity_id
        this.showBack = true;
      }
      /*获取列表*/
      this.getTableList();
    },
    methods: {
          /*返回上一页面*/
          gotoback(){
      this.$router.back(-1);
    },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    reast(){
      this.formInline.search = ""
      this.formInline.quanzi = ""
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        DynamicApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.dynamic_id = row.dynamic_id;
        this.open_edit = true
      },
      jumpClick(e){
        this.$router.push({
          path: '/plus/dynamic/comment',
          query: {
            name: e.name
          }
        });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DynamicApi.del(
              {
                dynamic_id: row.dynamic_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/dynamic/dynamic.vue